import React, { Component } from 'react'
import { todayString } from '../../util'
import Icon from "../../../../../../images/settings-icons/setting-daily-macros-adjust.png";
import { Accordion } from "./components/setting-accordion";
import { SaveButton } from "./components/save-button";
import styled from "styled-components";
import { updateMacroAdjustment } from "../../../../../../api";

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
class UpdateMovingTarget extends Component {
  constructor(props) {
    super(props)
    this.state = {
      movingTargetsOption: null,
      expanded: false,
      disableSubmit: true,
      isSubmitting: false,
      show: false,
    }
  }

  handlePanelChange = (event, expanded) => {
    this.setState({ expanded: expanded })
  }

  handleChange = (e) => {
    this.setState({
      movingTargetsOption: Number(e.target.value),
      disableSubmit: (Number(e.target.value) === this.props.movingTargetsOption)
    })
  }

  handleSubmit = () => {
    const today = todayString()
    const data = {
      moving_targets: this.state.movingTargetsOption,
      part_4_invoked: this.props.part4Invoked,
      part_4_fat_per_myriad: this.props.part4FatPerMyriad
    }
    this.setState({ isSubmitting: true })
    
    updateMacroAdjustment(this.props.userId, this.props.portalId, today, data)
      .then((res) => { 
        setTimeout(() => {
          this.setState({ isSubmitting: false });
          this.props.openSnackbar('Setting has been updated', false);
          this.props.loadPortalAccount();
        }, 1000);
      }).catch((err) => {
        setTimeout(() => {
          this.setState({ isSubmitting: false });
          this.props.openSnackbar('Setting failed to update', true)
        }, 1000);
      });
  }

  render() {
    const movingTargetsOption = this.state.movingTargetsOption === null ? this.props.movingTargetsOption : this.state.movingTargetsOption
    const savedOptionDescription = this.props.movingTargetsOption === 1 ? 'On: Aggressive' : (this.props.movingTargetsOption === 2 ? 'On: Dispersed' : 'Off')

    return (
      <Accordion
        show={this.state.show}
        setShow={(val) => this.setState({show: val})}  
        settingName="Daily macro adjustments"
        // description="New macros based on what you tracked the day before"
        icon={Icon}
        currentSetting={savedOptionDescription}
        // roundBottom
        // alternateColor
      >
        <>
          <p>Get new macro targets each day based on what was tracked the day before. If the user goes over or under their targets, the macros will be subtracted from or added to future days to get them back within range. Only turn on if the user will be logging all of their food every day.</p>
          <p><span style={{color: '#191f25', fontWeight:'bold'}}>Dispersed</span>: adjustment is spread evenly across the remainder of your check-in period (less aggressive)</p>
          <p><span style={{color: '#191f25', fontWeight:'bold'}}>Aggressive</span>: adjustment is reflected primarily on the next day (more aggressive)</p>
          <p><span style={{color: '#191f25', fontWeight:'bold'}}>Off</span>: not using daily macro adjustments</p>
          <div className='avn-button-radio-container'>
            <button onClick={this.handleChange} value={2} style={(movingTargetsOption === 2) ? activeStyle : null }>Dispersed</button>
            <button id='avn-toggle-radio-first' onClick={this.handleChange} value={1} style={(movingTargetsOption === 1) ? activeStyle : null }>Aggressive</button>
            <button onClick={this.handleChange} value={0} style={(movingTargetsOption === 0) ? activeStyle : null }>Off</button>
          </div>
          <ButtonRow>
            <SaveButton
              onClick={this.handleSubmit}
              isLoading={this.state.isSubmitting}
              disabled={this.state.disableSubmit}
            />
          </ButtonRow>
        </>
      </Accordion>
    )
  }
}

const activeStyle = {
  background: '#0ab23b',
  border: '1px solid #0ab23b',
  color: 'white'
}

// function mapStateToProps(state) {
//   return {
//     userId: state.user.id,
//     movingTargetsOption: state.user.macroData.movingTargets,
//     part4Invoked: state.user.macroData.part4Invoked,
//     part4FatPerMyriad: state.user.macroData.part4FatPerMyriad
//   }
// }

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({ loadProfile, updateMacroAdjustment, openFeedback }, dispatch);
// }

// export default connect(mapStateToProps, mapDispatchToProps)(UpdateMovingTarget)

export default UpdateMovingTarget;
